/**
 * Ключи запросов под фильтром темы (#2229) — одно правило для раздела «Голос
 * клиента» (`useVoiceOfCustomer`) и потока возражений (`useObjectionStream`):
 * организация — третий элемент ключа, тема — на своём месте от конца ключа
 * (`fromEnd`), `null` — без темы.
 */
import type { QueryFilters } from '@tanstack/react-query';

/** The theme slot of a key, `fromEnd` elements from its end. */
export function keyTheme(key: readonly unknown[], fromEnd: number): unknown {
  return key[key.length - fromEnd];
}

/**
 * Whether the previous answer may stand in while a new filter loads: the same
 * organization — never one tenant's customer words under another's name — the
 * same theme: another theme's numbers (or the whole stream's) are not this
 * filter's, and the screen would show them as such — and the same demo mode
 * (`'demo'`/`'own'`, `modeFromEnd` from the end): the demo of a closed section is never
 * drawn as the organization's own while its first answer loads after an
 * upgrade, nor the other way round (#2816).
 */
export function keepsThemePlaceholder(
  previousKey: readonly unknown[] | undefined,
  key: readonly unknown[],
  fromEnd: number,
  modeFromEnd: number
): boolean {
  return (
    previousKey !== undefined &&
    previousKey[2] === key[2] &&
    keyTheme(previousKey, fromEnd) === keyTheme(key, fromEnd) &&
    keyTheme(previousKey, modeFromEnd) === keyTheme(key, modeFromEnd)
  );
}

/** Every query under `prefix` (which ends with the organization) narrowed by a theme. */
export function themeFilteredQueries(
  prefix: readonly unknown[],
  fromEnd: number
): QueryFilters {
  return {
    queryKey: [...prefix],
    predicate: ({ queryKey }) => typeof keyTheme(queryKey, fromEnd) === 'string',
  };
}
